<app-header *ngIf="(deviceType$| async) === 'desktop'"></app-header>
<div class="w-100 bg-white">
    <div class="mobile-header-wrapper position-relative w-100">
        <app-header-mobile
            *ngIf="(deviceType$| async) === 'mobile' || (deviceType$| async) === 'tabletV' || (deviceType$| async) === 'tabletH'"></app-header-mobile>
    </div>
    <div class="container-fluid p-0">
        <app-breadcrumb></app-breadcrumb>
        <app-plugin-loader-global *ngIf="pageSnippets" [page]="page" [snippets]="pageSnippets" [hasLoaded]="hasLoaded"></app-plugin-loader-global>
        <!-- <app-plugin-loader *ngIf="pageSnippets" [page]="page" [snippets]="pageSnippets" [hasLoaded]="hasLoaded"></app-plugin-loader> -->
        <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
    <app-cookie-consent-dialog></app-cookie-consent-dialog>
    <app-fixed-elements></app-fixed-elements>
    <app-chat *ngIf="(overlays$ | async).chat"></app-chat>
    <app-menu-mobile
        *ngIf="(mobileMenu$ | async) && ((deviceType$ | async) === 'mobile' || (deviceType$ | async) === 'tabletV' || (deviceType$ | async) === 'tabletH')"></app-menu-mobile>
    <app-menu-mobile-user
        *ngIf="(mobileMenuUser$ |async) && ((deviceType$ | async) === 'mobile' || (deviceType$ | async) === 'tabletV' || (deviceType$ | async) === 'tabletH')"></app-menu-mobile-user>
<!--    <app-login-modal *ngIf="(overlays$ | async).loginModal"></app-login-modal>-->
<!--    <app-register-modal *ngIf="(overlays$ | async).registerModal"></app-register-modal>-->
<!--    <app-added-to-basket *ngIf="(overlays$ | async).addedToBasket"></app-added-to-basket>-->
</div>
